import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { KnowledgeEditorPage } from '@/components/knowledge/KnowledgeEditorPage'
import { useAuth } from '@/hooks/use-auth'
import type { KnowledgeArticleType } from '@/types/knowledge'

type NewKnowledgeSearch = {
  tipo?: KnowledgeArticleType
}

export const Route = createFileRoute('/_app/conhecimento/novo')({
  validateSearch: (search): NewKnowledgeSearch => {
    const tipo = search.tipo === 'DOCUMENT' ? 'DOCUMENT' : 'TEXT'
    return { tipo }
  },
  component: NewKnowledgePage,
})

function NewKnowledgePage() {
  const navigate = useNavigate()
  const { currentOrgId } = useAuth()
  const { tipo } = Route.useSearch()

  function backToList() {
    void navigate({ to: '/conhecimento' })
  }

  if (!currentOrgId) {
    return (
      <div className="text-muted-foreground flex flex-1 items-center justify-center">
        Selecione uma organização
      </div>
    )
  }

  return (
    <KnowledgeEditorPage
      orgId={currentOrgId}
      defaultType={tipo}
      onCancel={backToList}
      onSuccess={backToList}
    />
  )
}
